var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#DB536A;}\r\n\t.st2{fill:#E0301E;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#464646;}\r\n\t.st5{fill:#7D7D7D;}\r\n\t.st6{fill:#2D2D2D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2_9_",
    d: "M77.8,81l-57.2,0l-0.1-57.1l28.7,0l11.7,0l0-4.5l-11.7,0l-28.7,0c-2.4,0-4.4,2-4.4,4.4l0,61.7l61.7,0 c2.4,0,4.4-2,4.4-4.4l0-40.4l-4.5,0L77.8,81z M44.5,53.9l3.2,3.2l4.5-4.5l-3.2-3.2L44.5,53.9z M84.8,13.5l-3.6,3.6L79,19.3l-4.5,4.5 l-2.2,2.2l-20,20l3.2,3.2l20-20l2.3-2.3l4.5-4.5l2.2-2.2l3.6-3.6L84.8,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.eda53431ba4beebd61fe73985d5eecc9.svg";
export { ForwardRef as ReactComponent };